import type { SVGProps } from 'react';

export default function Fallback(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} />;
}
